'use strict'
import Vue from 'vue'

const Role = {}

const roles = [
  { text: 'Administrateur', value: 'ROLE_ADMIN', level: 4 },
  { text: 'Consultant', value: 'ROLE_BROWSER', level: 3 },
  { text: 'Commercial', value: 'ROLE_COMMERCIAL', level: 2 },
  { text: 'Partenaire', value: 'ROLE_PARTNER', level: 1 },
  { text: 'Aucun', value: 'NONE', level: 0 }
]

// eslint-disable-next-line no-unused-vars
Role.install = function (Vue, options) {
  /**
   * @param {string} roleName - role name. Ex: ROLE_ADMIN
   */
  Role.getRoleLevel = function (roleName = 'ROLE_PARTNER') {
    let level = 0
    roles.forEach((role) => {
      if (role.value === roleName) {
        level = role.level
      }
    })
    return level
  }

  Role.checkRoleLevel = function (roleInf = 'ROLE_PARTNER', roleSup = 'ROLE_ADMIN') {
    const lvInf = Role.getRoleLevel(roleInf)
    const lvSup = Role.getRoleLevel(roleSup)
    return lvInf >= lvSup
  }

  Role.authorized = function (roles) {
    if (Vue.prototype.$auth.check()) {
      if (roles instanceof Array) {
        let valid = false
        Vue.prototype._.each(roles, (role) => {
          if (Role.checkRoleLevel(Vue.prototype.$auth.user().role, role)) {
            valid = true
          }
        })
        return valid
      } else {
        return Role.checkRoleLevel(Vue.prototype.$auth.user().role, roles)
      }
    }
    return false
  }

  Role.authorizedArray = function (roles) {
    if (Vue.prototype.$auth.check()) {
      let valid = false
      for (const role of roles) {
        if (Vue.prototype.$auth.user().role === role) {
          valid = true
          break
        }
      }
      // Vue.prototype._.each(roles, (role) => {
      //   if (Vue.prototype.$auth.user().role === role) {
      //     valid = true
      //   }
      // })
      return valid
      // return Vue.prototype.$auth.check(roles)
    }
    return false
  }

  Role.authorizedOnly = function (role) {
    if (Vue.prototype.$auth.check()) {
      return Vue.prototype.$auth.user().role === role
    }
    return false
  }

  if (!Vue.$role) {
    Vue.$role = Role
    Object.defineProperties(Vue.prototype, {
      $role: {
        get () {
          return Role
        }
      }
    })
  }
}
Vue.use(Role)
